import { ActionReducerMapBuilder, createSlice, PayloadAction } from "@reduxjs/toolkit";

import { createGlobalProfile, patchPopupTranslation, postPopupTranslation, setConfigWheel, updateConfigWheelById, updateGlobalProfile } from "../thunks";

import { IGlobalProfile, ITranslationProfile, IWheelConfige, WheelProfileGlobal, WheelProfileReward } from "../../../entities/wheelGame";
import { getWheelProfile, getWheelProfileConfiguration, getWheelProfilePopup, getWheelProfileReward, getWheelProfileThemes, patchWheelProfile, patchWheelProfileConfiguration, postWheelProfile, postWheelProfileConfiguration } from "./thunks";

interface WheelState {
  loading: boolean,
  saveLoading: boolean,
  loadedProfile: boolean,
  loadingProfile: boolean,
  loadingPrizeTranslation: boolean;
  editGlobalProfile?: WheelProfileGlobal,
  wheelConfige: IWheelConfige[],
  themes: string[];
  translations: ITranslationProfile[],
  reward: WheelProfileReward
}

const initialState: WheelState = {
  loading: false,
  saveLoading: false,
  loadedProfile: false,
  loadingProfile: false,
  loadingPrizeTranslation: false,
  wheelConfige: [],
  translations: [],
  themes: [],
  reward: {
    config: {
      isEnabled: false,
      url: ""
    },
    rewards: []
  },
}

const addLoadingCases = (
  builder: ActionReducerMapBuilder<WheelState>,
  action: any
) => {
  builder.addCase(action.pending, (state: WheelState) => {
    state.saveLoading = true;
  });

  builder.addCase(action.fulfilled, (state: WheelState) => {
    state.saveLoading = false;
  });
};

export const wheelProfileSlice = createSlice({
  name: "wheelProfile",
  initialState,
  reducers: {
    setGlobalProfile: (state, action: PayloadAction<WheelProfileGlobal>) => {
      state.editGlobalProfile = action.payload
    },
    unsetGlobalProfile: (state) => {
      state.editGlobalProfile = undefined;
      state.loadedProfile = false;
    },
  },
  extraReducers: (builder) => {
    // getWheelProfileThemes 
    builder.addCase(getWheelProfileThemes.pending, (state) => {
      state.loading = true;
    })

    builder.addCase(getWheelProfileThemes.fulfilled, (state, action) => {
      state.themes = action.payload;
      state.loading = false;
    })
    // postWheelProfile
    builder.addCase(postWheelProfile.pending, (state) => {
      state.saveLoading = true;
    })

    builder.addCase(postWheelProfile.fulfilled, (state, action) => {
      state.editGlobalProfile = action.payload;
      state.saveLoading = false;
      state.loadedProfile = true;
    })
    builder.addCase(postWheelProfile.rejected, (state) => {
      state.saveLoading = false;
      state.loadedProfile = false;
    })

    // getWheelProfile
    builder.addCase(getWheelProfile.pending, (state) => {
      state.loading = true;
    })

    builder.addCase(getWheelProfile.fulfilled, (state, action) => {
      state.editGlobalProfile = action.payload;
      state.loading = false;
      state.loadedProfile = true;
    })
    // patchWheelProfile
    builder.addCase(patchWheelProfile.pending, (state) => {
      state.saveLoading = true;
    })

    builder.addCase(patchWheelProfile.fulfilled, (state, action) => {
      state.editGlobalProfile = action.payload;
      state.saveLoading = false;
      state.loadedProfile = true;
    })
    builder.addCase(patchWheelProfile.rejected, (state) => {
      state.saveLoading = false;
      state.loadedProfile = false;
    })

    // getWheelProfileConfiguration
    builder.addCase(getWheelProfileConfiguration.pending, (state) => {
      state.loading = true;
    })

    builder.addCase(getWheelProfileConfiguration.fulfilled, (state, action) => {
      state.wheelConfige = action.payload;
      state.loading = false;
      state.loadedProfile = true;
    })
    // getWheelProfilePopup
    builder.addCase(getWheelProfilePopup.pending, (state) => {
      state.loading = true;
    })

    builder.addCase(getWheelProfilePopup.fulfilled, (state, action) => {
      state.translations = action.payload;
      state.loading = false;
      state.loadedProfile = true;
    })

    // getWheelProfileReward
    builder.addCase(getWheelProfileReward.pending, (state) => {
      state.loading = true;
    })

    builder.addCase(getWheelProfileReward.fulfilled, (state, action) => {
      state.reward = action.payload;
      state.loading = false;
      state.loadedProfile = true;
    })
    // patchWheelProfileConfiguration
    builder.addCase(patchWheelProfileConfiguration.pending, (state) => {
      state.saveLoading = true;
    })

    builder.addCase(patchWheelProfileConfiguration.fulfilled, (state, action) => {
      state.wheelConfige = action.payload;
      state.saveLoading = false;
    })
    // postWheelProfileConfiguration
    builder.addCase(postWheelProfileConfiguration.pending, (state) => {
      state.saveLoading = true;
    })

    builder.addCase(postWheelProfileConfiguration.fulfilled, (state, action) => {
      state.wheelConfige = action.payload;
      state.saveLoading = false;
    })
    const saveActions = [
      // postWheelProfileConfiguration,
      // patchWheelProfileConfiguration,
      updateConfigWheelById,
      postPopupTranslation,
      patchPopupTranslation,
      updateGlobalProfile,
    ];
    saveActions.forEach((action) => addLoadingCases(builder, action));
  },
});

export const { unsetGlobalProfile, setGlobalProfile } = wheelProfileSlice.actions;

export default wheelProfileSlice.reducer;
